export const CONTACT_ADVANCED_FILTERS_KEY = 'contacts-advanced-filters';

export const CONTACT_CREATE_PATH = '/management/contacts/create';

export const NO_DISPLAYABLE_CONTACTS_FILTERS = [
    'page',
    'limit',
    'isSearching',
    'isQueryEnabled',
    'isTabsEnabled',
    'tabValue',
    'createdBy',
    'users',
];
